var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlanPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F0F6FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1171 11.9988C13.6358 11.9988 14.867 10.7676 14.867 9.24891C14.867 7.73019 13.6358 6.49902 12.1171 6.49902C10.5984 6.49902 9.36719 7.73019 9.36719 9.24891C9.36719 10.7676 10.5984 11.9988 12.1171 11.9988Z",
    fill: "#032279"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1248 12.9165C9.8478 12.919 8.00254 14.7643 8 17.0413C8 17.2945 8.20519 17.4996 8.45831 17.4996H15.7913C16.0445 17.4996 16.2496 17.2945 16.2496 17.0413C16.2471 14.7643 14.4019 12.919 12.1248 12.9165Z",
    fill: "#032279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlanPrint);
export default __webpack_public_path__ + "static/media/userPlanPrint.b529b6fea450e4099fbe074e20083574.svg";
export { ForwardRef as ReactComponent };